var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0039 15.4585L20.0629 19.5M11.0625 6.5C13.2716 6.5 15.0625 8.29086 15.0625 10.5M18.0625 10.5C18.0625 6.63401 14.9285 3.5 11.0625 3.5C7.19651 3.5 4.0625 6.63401 4.0625 10.5C4.0625 14.366 7.19651 17.5 11.0625 17.5C14.9285 17.5 18.0625 14.366 18.0625 10.5Z",
    stroke: "#675D75",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.e6d24691edec5f878f4f38d3b945f511.svg";
export { ForwardRef as ReactComponent };